import React, { useState } from "react";
import styles from "./BetTableAaa.module.css";

// Info tooltip component
const InfoTooltip = ({ min, max, tooltipId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleTooltip = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.infoBlock} onClick={(e) => e.stopPropagation()}>
      <a 
        className={styles.infoIcon}
        onClick={toggleTooltip}
        style={{ cursor: 'pointer' }}
      >
        <i className="fas fa-info-circle m-l-10"></i>
      </a>
      {isOpen && (
        <div className={styles.minMaxInfo} onClick={(e) => e.stopPropagation()}>
          <span className={styles.mr5}>
            <b>Min:</b> <span>{typeof min === 'number' ? min.toFixed(1) : (min?.toString() || "100.0")}</span>
          </span>
          <span className={styles.mr5}>
            <b>Max:</b> <span>{max?.toString() || "100K"}</span>
          </span>
        </div>
      )}
    </div>
  );
};

export default function BetTableAaa({ runnersData = [], exposures = {} }) {
  const getExposure = (runnerName) => {
    const exposureKeys = [
      runnerName,
      runnerName?.toLowerCase(),
      runnerName?.trim()
    ];
    
    for (const key of exposureKeys) {
      if (key && exposures[key] !== undefined) {
        return exposures[key];
      }
    }
    return 0;
  };

  const formatExposure = (value) => {
    if (value === null || value === undefined || value === 0) return "0";
    if (value >= 1000) {
      return `${(value / 1000).toFixed(0)}K`;
    }
    return value.toFixed(2);
  };

  const isLocked = (val, gstatus) => {
    return val === undefined || val === null || Number(val) === 0 || gstatus?.toUpperCase() === "SUSPENDED";
  };

  const isSuspended = (betData) => {
    return betData?.gstatus?.toUpperCase() === "SUSPENDED";
  };

  // Get bet data by sid
  const getBetData = (sid) => {
    return runnersData.find(item => item?.sid === sid) || {};
  };

  // Players: A. Amar (sid 1), B. Akbar (sid 2), C. Anthony (sid 3)
  const players = [
    { sid: 1, label: "A.", name: "Amar" },
    { sid: 2, label: "B.", name: "Akbar" },
    { sid: 3, label: "C.", name: "Anthony" },
  ].map(player => ({
    ...player,
    betData: getBetData(player.sid)
  }));

  // Even/Odd options (sid 4-5)
  const evenOption = getBetData(4);
  const oddOption = getBetData(5);

  // Suits: Red (sid 6), Black (sid 7)
  const redOption = getBetData(6);
  const blackOption = getBetData(7);

  // Under/Over 7 (sid 8-9)
  const under7Option = getBetData(8);
  const over7Option = getBetData(9);

  // Card mapping with images
  const cards = [
    { value: "A", image: "/assets/img/aa2/A.png", apiValue: "1" },
    { value: "2", image: "/assets/img/aa2/2.png", apiValue: "2" },
    { value: "3", image: "/assets/img/aa2/3.png", apiValue: "3" },
    { value: "4", image: "/assets/img/aa2/4.png", apiValue: "4" },
    { value: "5", image: "/assets/img/aa2/5.png", apiValue: "5" },
    { value: "6", image: "/assets/img/aa2/6.png", apiValue: "6" },
    { value: "7", image: "/assets/img/aa2/7.png", apiValue: "7" },
    { value: "8", image: "/assets/img/aa2/8.png", apiValue: "8" },
    { value: "9", image: "/assets/img/aa2/9.png", apiValue: "9" },
    { value: "10", image: "/assets/img/aa2/10.png", apiValue: "10" },
    { value: "J", image: "/assets/img/aa2/J.png", apiValue: "J" },
    { value: "Q", image: "/assets/img/aa2/Q.png", apiValue: "Q" },
    { value: "K", image: "/assets/img/aa2/K.png", apiValue: "K" },
  ];

  // Card options (sid 10-22 for A, 2-10, J, Q, K)
  const cardOptions = cards.map((card, index) => ({
    sid: 10 + index,
    name: card.value,
    betData: getBetData(10 + index),
    image: card.image,
    apiValue: card.apiValue
  }));

  return (
    <div style={{ width: '100%' }}>
      {/* Players Section */}
      <div className={`${styles.aaaContent} ${styles.mt10}`}>
        <div className={styles.row}>
          <div className={styles.col12}>
            <div className={styles.textRight}>
              <InfoTooltip 
                min={players[0]?.betData?.min || 100} 
                max={players[0]?.betData?.max ? (players[0].betData.max >= 1000 ? `${(players[0].betData.max / 1000).toFixed(0)}K` : players[0].betData.max) : "300K"} 
                tooltipId="min-max-info1" 
              />
            </div>
          </div>
        </div>
        <div className={styles.row}>
          {players.map((player) => {
            const playerBet = player.betData;
            const isBackLocked = isLocked(playerBet?.b, playerBet?.gstatus);
            const isLayLocked = isLocked(playerBet?.l, playerBet?.gstatus);
            const isSuspendedRow = isSuspended(playerBet);
            const exposure = getExposure(player.name);
            
            return (
              <div key={player.sid} className={`${styles.col4} ${styles.textCenter}`}>
                <div>
                  <span className={styles.dBlock}>
                    <b>
                      <span className={styles.textDanger}>{player.label}</span>
                      <span style={{color:'white'}}>         {player.name}</span>
              
                    </b>
                  </span>
                </div>
                <div className={`${styles.aaaButton} ${isSuspendedRow ? styles.suspended : ""}`}>
                  <button className={styles.back} style={{ 
                    cursor: isBackLocked ? 'not-allowed' : 'default',
                    backgroundColor: isBackLocked ? 'rgba(217, 220, 223)' : '#72bbef',
                    background: isBackLocked ? 'rgba(217, 220, 223)' : '#72bbef'
                  }}>
                    <span className={styles.odd}>{isBackLocked ? "0" : (playerBet?.b || "0")}</span>
                  </button>
                  <button className={styles.lay} style={{ 
                    cursor: isLayLocked ? 'not-allowed' : 'default',
                    backgroundColor: isLayLocked ? 'rgba(217, 220, 223)' : '#faa9ba',
                    background: isLayLocked ? 'rgba(217, 220, 223)' : '#faa9ba'
                  }}>
                    <span className={styles.odd}>{isLayLocked ? "0" : (playerBet?.l || "0")}</span>
                  </button>
                </div>
                <span className={`${styles.dBlock} ${styles.mt5}`} style={{ color: 'black' }}>
                  {exposure !== 0 ? formatExposure(exposure) : "0"}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      {/* Even/Odd, Suits, Under/Over 7 Section */}
      <div className={styles.row} style={{ marginTop: '10px' }}>
        {/* Even/Odd Column */}
        <div className={styles.col4}>
          <div className={styles.aaaContent}>
            <div className={styles.textRight}>
              <InfoTooltip 
                min={evenOption?.min || 100} 
                max={evenOption?.max ? (evenOption.max >= 1000 ? `${(evenOption.max / 1000).toFixed(0)}K` : evenOption.max) : "25K"} 
                tooltipId="min-max-info2" 
              />
            </div>
            <div className={styles.textCenter}>
              <div style={{color:'white'}}><b>{evenOption?.b || "2.12"}</b></div>
              <div className={`${styles.mb5} ${styles.mt5}`}>
                <button className={`${styles.textUppercase} ${styles.lowHighBtn} ${isLocked(evenOption?.b, evenOption?.gstatus) ? styles.suspended : ""}`}>
                  <b>Even</b>
                </button>
              </div>
              <div style={{ color: 'black' }}>
                {getExposure("Even") !== 0 ? formatExposure(getExposure("Even")) : "0"}
              </div>
            </div>
            <div className={`${styles.textCenter} ${styles.mt10}`}>
              <div style={{color:'white'}}><b>{oddOption?.b || "1.83"}</b></div>
              <div className={`${styles.mb5} ${styles.mt5}`}>
                <button className={`${styles.textUppercase} ${styles.lowHighBtn} ${isLocked(oddOption?.b, oddOption?.gstatus) ? styles.suspended : ""}`}>
                  <b>Odd</b>
                </button>
              </div>
              <div style={{ color: 'black' }}>
                {getExposure("Odd") !== 0 ? formatExposure(getExposure("Odd")) : "0"}
              </div>
            </div>
          </div>
        </div>

        {/* Suits Column */}
        <div className={styles.col4}>
          <div className={styles.aaaContent}>
            <div className={styles.textRight}>
              <InfoTooltip 
                min={redOption?.min || 100} 
                max={redOption?.max ? (redOption.max >= 1000 ? `${(redOption.max / 1000).toFixed(0)}K` : redOption.max) : "25K"} 
                tooltipId="min-max-info3" 
              />
            </div>
            <div className={styles.textCenter}>
              <div style={{color:'white'}}><b>{redOption?.b || "1.97"}</b></div>
              <div className={`${styles.mb5} ${styles.mt5}`}>
                <button className={`${styles.textUppercase} ${styles.lowHighBtn} ${isLocked(redOption?.b, redOption?.gstatus) ? styles.suspended : ""}`}>
                  <span className={styles.cardIcon}>
                    <span className={styles.cardRed}>♥</span>
                  </span>
                  <span className={styles.cardIcon}>
                    <span className={styles.cardRed}>♦</span>
                  </span>
                </button>
              </div>
              <div style={{ color: 'black' }}>
                {getExposure("Red") !== 0 ? formatExposure(getExposure("Red")) : "0"}
              </div>
            </div>
            <div className={`${styles.textCenter} ${styles.mt10}`}>
              <div style={{color:'white'}}><b>{blackOption?.b || "1.97"}</b></div>
              <div className={`${styles.mb5} ${styles.mt5}`}>
                <button className={`${styles.textUppercase} ${styles.lowHighBtn} ${isLocked(blackOption?.b, blackOption?.gstatus) ? styles.suspended : ""}`}>
                  <span className={styles.cardIcon}>
                    <span className={styles.cardBlack}>♠</span>
                  </span>
                  <span className={styles.cardIcon}>
                    <span className={styles.cardBlack}>♣</span>
                  </span>
                </button>
              </div>
              <div style={{ color: 'black' }}>
                {getExposure("Black") !== 0 ? formatExposure(getExposure("Black")) : "0"}
              </div>
            </div>
          </div>
        </div>

        {/* Under/Over 7 Column */}
        <div className={styles.col4}>
          <div className={styles.aaaContent}>
            <div className={styles.textRight}>
              <InfoTooltip 
                min={under7Option?.min || 100} 
                max={under7Option?.max ? (under7Option.max >= 1000 ? `${(under7Option.max / 1000).toFixed(0)}K` : under7Option.max) : "100K"} 
                tooltipId="min-max-info4" 
              />
            </div>
            <div className={styles.textCenter}>
              <div style={{color:'white'}}><b>{under7Option?.b || "2"}</b></div>
              <div className={`${styles.mb5} ${styles.mt5}`}>
                <button className={`${styles.textUppercase} ${styles.lowHighBtn} ${isLocked(under7Option?.b, under7Option?.gstatus) ? styles.suspended : ""}`}>
                  <b>Under 7</b>
                </button>
              </div>
              <div style={{ color: 'black' }}>
                {getExposure("Under 7") !== 0 ? formatExposure(getExposure("Under 7")) : "0"}
              </div>
            </div>
            <div className={`${styles.textCenter} ${styles.mt10}`}>
              <div style={{color:'white'}}><b>{over7Option?.b || "2"}</b></div>
              <div className={`${styles.mb5} ${styles.mt5}`}>
                <button className={`${styles.textUppercase} ${styles.lowHighBtn} ${isLocked(over7Option?.b, over7Option?.gstatus) ? styles.suspended : ""}`}>
                  <b>Over 7</b>
                </button>
              </div>
              <div style={{ color: 'black' }}>
                {getExposure("Over 7") !== 0 ? formatExposure(getExposure("Over 7")) : "0"}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Cards Section */}
      <div className={`${styles.aaaContent} ${styles.mt10}`} style={{ flex: 1, width: '100%' }}>
        <div className={styles.row}>
          <div className={styles.col12}>
            <div className={styles.textRight}>
              <InfoTooltip 
                min={cardOptions[0]?.betData?.min || 100} 
                max={cardOptions[0]?.betData?.max ? (cardOptions[0].betData.max >= 1000 ? `${(cardOptions[0].betData.max / 1000).toFixed(0)}K` : cardOptions[0].betData.max) : "5K"} 
                tooltipId="min-max-info5" 
              />
            </div>
          </div>
        </div>
        <div className={styles.row}>
          <div className={`${styles.col12} ${styles.textCenter}`} style={{ color: 'white' }}>
            <b>{cardOptions.every(card => isLocked(card.betData?.b, card.betData?.gstatus)) ? "0" : "12"}</b>
          </div>
        </div>
        <div className={`${styles.row} ${styles.mt10}`}>
          <div className={`${styles.col12} ${styles.textCenter}`}>
            {cardOptions.map((card, index) => {
              const betData = card.betData;
              const locked = isLocked(betData?.b, betData?.gstatus);
              const exposure = getExposure(`Card ${card.name}`);
              return (
                <div key={card.sid} className={`${styles.mr5} card-image`}>
                  <div className={locked ? "suspended" : ""}>
                    <img src={card.image} alt={`Card ${card.name}`} />
                  </div>
                  <div className="ubook text-center m-t-5" style={{ color: 'white' }}>
                    {exposure !== 0 ? formatExposure(exposure) : "0"}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
